<template>
  <div :class="$style.container">
    <span :class="$style.label">Описание:</span>
    {{ issue.description }}
  </div>
</template>

<script>
export default {
  name:  "IssueDescription",
  props: ['issue'],
};
</script>

<style lang="scss" module>
.container {
  border: 1px solid #F0F0F0;
  border-radius: 4px;
  padding: 8px 14px;
  font-size: 1.15rem;
  //overflow: auto;
  margin-bottom: 20px;
  //max-height: 100%;
  //height: 100%;
  word-wrap: break-word;
  white-space: pre-line;
}

.label {
  font-weight: 600;
  margin-right: .3em;
}
</style>
